export const tokens = {
  colors: {
    palette: {
      black: '#070709',
      darkgray: '#6B6B6D',
      lightgray: '#B2B2B4',
      light: '#E6E6E8',
      white: '#FFFFFF',
    },
    primary: {
      main: '#3F3F46',
      light: '#6D6D6D',
      dark: '#1C1C1E',
    },
    secondary: {
      main: '#64748b',
      light: '#94a3b8',
      dark: '#475569',
    },
    success: {
      main: '#2E7D32',
      light: '#4CAF50',
      dark: '#1B5E20',
    },
    error: {
      main: '#D32F2F',
      light: '#EF5350',
      dark: '#C62828',
    },
    warning: {
      main: '#ED6C02',
      light: '#FF9800',
      dark: '#C77700',
    },
    background: {
      default: '#f3f4f6', // gray-100
      light: '#f9fafb', // gray-50
      dark: '#e5e7eb', // gray-200
    },
    border: {
      default: '#9ca3af', // gray-400
      dark: '#4b5563', // gray-600
      light: '#f3f4f6', // gray-100
    },
    chart: {
      expense: '#ff4444',
      income: '#22cc44',
      trend: '#4488ff',
    },
  },
  borderRadius: {
    sm: '0.25rem',
    md: '0.375rem',
    lg: '0.5rem',
  },
} as const; 